import * as types from "./types"

export default {
  [types.USER_REG_FORM](state) {
    return state[types.USER_REG_FORM]
  },
  [types.INDEX_DATA_KNOWLAGE](state) {
    return state[types.INDEX_DATA_KNOWLAGE]
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js